import { WebgisUrlParameter } from './webgis-url-parameter.model';

/**
 * Holds params for a WebgisLink and composits them to a url
 */
export class WebgisLink {
  private _functionParam: WebgisUrlParameter;
  private _otherParams: WebgisUrlParameter[];

  constructor(functionParam: WebgisUrlParameter, otherParams: WebgisUrlParameter[]) {
    this._functionParam = functionParam;
    this._functionParam.addParameterNameSuffix('?');
    this.otherPrams = otherParams;
  }

  set otherPrams(otherParams: WebgisUrlParameter[]) {
    this._otherParams = otherParams;
    this._otherParams.forEach(param => {
      param.addParameterNameSuffix('&');
    });
  }

  /**
   * composits the baseUrl with all defined params
   * @param baseUrl the whole url without any params
   */
  public compositedWebgisLink(baseUrl: string): string {
    let compositedWebgisLink = baseUrl;
    this._otherParams.unshift(this._functionParam);
    this._otherParams.forEach(param => {
      compositedWebgisLink += param.compositedNameAndValue();
    });
    return compositedWebgisLink;
  }
}
